"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const joi = require("@hapi/joi");
exports.validateJoi = (schema = joi.object()) => (payload) => {
    const { value, error } = joi.validate(payload, schema, { allowUnknown: true, stripUnknown: true });
    // tslint:disable-next-line:strict-boolean-expressions
    if (error) {
        throw error;
    }
    else {
        return value;
    }
};



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/serverless-pagination/dist/src/util/validateJoi.js